<template>
  <div id="main">
    <!-- ======= Portfolio Section ======= -->
    <section id="portfolio" class="portfolio section-bg">
      <div class="container">
        <div class="">
          <h2 class="clearfix">Portfolio</h2>
          <div class="previous-section float-left">
            <a
              name=""
              id=""
              class="btn btn-primary d-xl-none"
              href="/resume"
              role="button"
              >Go to Previous Section</a
            >
          </div>
          <div class="next-section float-right">
            <a
              name=""
              id=""
              class="btn btn-primary d-xl-none"
              href="/services"
              role="button"
              >Go to Next Section</a
            >
          </div>
        </div>

        <div class="row" data-aos="fade-up">
          <div class="col-lg-12 d-flex justify-content-center">
            <ul id="portfolio-fliters">
              <li @click="filterKey = 'all'">All</li>
              <li @click="filterKey = 'web'">Programming</li>
              <li @click="filterKey = 'UI'">UI/UX</li>
              <li @click="filterKey = 'data'">Data Analysis</li>
              <li @click="filterKey = 'wordpress'">WordPress</li>
            </ul>
          </div>
        </div>
        <!-- Add Portfolio Item-->
        <div
          class="row portfolio-container"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div
            class="col-lg-4 col-md-6 portfolio-item filter-web"
            v-for="element in itemFilter"
            :key="element.id"
          >
            <PortfolioItem
              @details="showModal($event)"
              @lightbox="itemId($event)"
              v-bind:item="element"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- End Portfolio Section -->
    <modal name="PortfolioDetails">
      <PortfolioDetails />
    </modal>

    <CoolLightBox
      :items="lightboximg"
      :index="index"
      :useZoomBar="true"
      :effect="'fade'"
      @close="closeLightbox"
    >
    </CoolLightBox>
  </div>
</template>

<script>
// @ is an alias to /src
// import SweetModal from "sweet-modal-vue/src/plugin.js";
import PortfolioItem from "@/components/Portfolio-item";
import PortfolioDetails from "@/components/portfolio-details";

export default {
  name: "Home",
  components: {
    PortfolioItem,
    PortfolioDetails
  },
  data: function() {
    return {
      filterKey: "all",
      index: null,
      active: 1,
      lightboximg: [],
      details: [],
      lists: [
        {
          id: 0,
          title: "Blog App",
          src: require("../assets/img/blog/Blog Thumb.png"),
          type: "web",
          description:
            "This is a blog website made with Laravel. It also has an admin interface for creating, editing of posts, creation of roles and adding of users such as editors, contributors etc.",
          url: "https://github.com/Joenif/Blog-with-voyager",
          images: [
            require("../assets/img/blog/Blog web 1.png"),
            require("../assets/img/blog/Blog web 2.png"),
            require("../assets/img/blog/Blog Admin 1.png"),
            require("../assets/img/blog/Blog Admin 2.jpg"),
            require("../assets/img/blog/Blog Admin 3.jpg"),
            require("../assets/img/blog/Blog Admin 4.jpg")
          ]
        },
        {
          id: 1,
          title: "Admin Dashoard",
          src: require("../assets/img/admin/adminD thumb.jpg"),
          type: "web",
          description: "This is an Admin Dashboard with Laravel and Vuejs.",
          url: "https://github.com/Joenif/admin-dashboard",
          images: [
            require("../assets/img/admin/adminD 1.png"),
            require("../assets/img/admin/adminD 2.png"),
            require("../assets/img/admin/adminD 3.jpg"),
            require("../assets/img/admin/adminD thumb.jpg"),
            require("../assets/img/admin/adminD 5.jpg"),
            require("../assets/img/admin/adminD 6.png")
          ]
        },
        {
          id: 2,
          title: "Netflix Data Analysis",
          src: require("../assets/img/data/DA 1.jpg"),
          type: "data",
          description:
            "This contains the exploration and visualization of Netflix Tv and Movies show",
          url:
            "https://jovian.ml/josephnifemi89/explanatory-data-analysis-netflix",
          images: [require("../assets/img/data/DA 1.jpg")]
        },
        {
          id: 3,
          title: "Chat App Design",
          src: require("../assets/img/chatUI/loginD.png"),
          type: "UI",
          description:
            "This is a Login and Registration page made with Figma for desktop view",
          url: "",
          images: [
            require("../assets/img/chatUI/loginD.png"),
            require("../assets/img/chatUI/RegisterD.png")
          ]
        },
        {
          id: 4,
          title: "Business Design",
          src: require("../assets/img/business/homepage.jpg"),
          type: "UI",
          description: "This contains homepage and signup page for business",
          url: "",
          images: [
            require("../assets/img/business/homepage.jpg"),
            require("../assets/img/business/signup.jpg")
          ]
        },
        {
          id: 5,
          title: "E-learning website/LMS",
          src: require("../assets/img/knewidea/knewidea0.jpg"),
          type: "wordpress",
          description:
            "This is an online course website made with wordpress and learndash.",
          url: "knewidea.com",
          images: [
            require("../assets/img/knewidea/knewidea0.jpg"),
            require("../assets/img/knewidea/knewidea1.png"),
            require("../assets/img/knewidea/knewidea2.png"),
            require("../assets/img/knewidea/knewidea3.png"),
            require("../assets/img/knewidea/knewidea4.png")
          ]
        },
        {
          id: 6,
          title: "Chat App Mobile Design",
          src: require("../assets/img/chatUI mobile/Chatapp thumb.jpg"),
          type: "UI",
          description: "This is a Chat App UI design made with Figma",
          url: "",
          images: [
            require("../assets/img/chatUI mobile/Chatapp1.jpg"),
            require("../assets/img/chatUI mobile/Chatapp2.jpg"),
            require("../assets/img/chatUI mobile/Chatapp3.jpg"),
            require("../assets/img/chatUI mobile/Chatapp4.jpg"),
            require("../assets/img/chatUI mobile/Chatapp5.jpg"),
            require("../assets/img/chatUI mobile/Chatapp6.jpg"),
            require("../assets/img/chatUI mobile/Chatapp thumb.jpg")
          ]
        },
        {
          id: 7,
          title: "Online Course Website for Monbaceco",
          src: require("../assets/img/monbaceco/monbaceco1.png"),
          type: "wordpress",
          description:
            "We setup learnpress for this website and customize it for courses.",
          url: "",
          company: "Monbaceco",
          images: [
            require("../assets/img/monbaceco/monbaceco1.png"),
            require("../assets/img/monbaceco/monbaceco2.png"),
            require("../assets/img/monbaceco/monbaceco3.png")
          ]
        }
      ]
    };
  },
  computed: {
    itemFilter() {
      return this[this.filterKey];
    },
    all() {
      return this.lists;
    },
    web() {
      return this.lists.filter(list => list.type == "web");
    },
    wordpress() {
      return this.lists.filter(list => list.type == "wordpress");
    },
    UI() {
      return this.lists.filter(list => list.type == "UI");
    },
    data() {
      return this.lists.filter(list => list.type == "data");
    }
  },
  methods: {
    showModal(item) {
      this.details.push(item);
      this.$modal.show(PortfolioDetails, { element: item });
    },
    closeLightbox() {
      while (this.lightboximg.length > 0) {
        this.lightboximg.pop();
      }
      this.index = null;
    },
    itemId(id) {
      this.lists.forEach(list => {
        if (list.id == id) {
          list.images.forEach((value, index) => {
            this.index = index;
            this.lightboximg.push(value);
          });
        }
      });
    }
  }
};
</script>
